import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useEffect } from 'react';
import { useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useDetectUserDetails = () => {
    const dispatch = useDispatch();
    const userDetails = useUserSelector(prop('userDetails'));

    useEffect(() => {
        if (userDetails?.currency) {
            dispatch(actions.setCurrencyCode(userDetails.currency));
        }

        if (userDetails?.countryCode) {
            dispatch(actions.setCountry(userDetails.countryCode));
        }
    }, [userDetails, dispatch]);
};
